import { lt } from '@mews/framework';
import { Button, Dialog, DialogProps } from '@optimus-web/core';

export interface ConfirmationDialogProps extends Pick<DialogProps, 'loading' | 'active' | 'onClose'> {
    description: Mews.TextKey;
    isLoading: boolean;
    onConfirm: () => void;
    primaryButtonText: Mews.TextKey;
    title: Mews.TextKey;
}

export const ConfirmationDialog = ({
    active,
    description,
    isLoading,
    onConfirm,
    onClose,
    primaryButtonText,
    title,
}: ConfirmationDialogProps) => (
    <Dialog
        modal
        size="small"
        loading={isLoading}
        footer={{
            primary: (
                <Button size="medium" variant="primary" onClick={onConfirm} data-test-button-action="0" type="submit">
                    {lt(primaryButtonText)}
                </Button>
            ),
            secondary: (
                <Button size="medium" variant="tertiary" onClick={onClose} type="submit">
                    {lt('GoBack')}
                </Button>
            ),
        }}
        active={active}
        onClose={onClose}
        title={lt(title)}
    >
        {lt(description)}
    </Dialog>
);
